export default __webpack_public_path__ + "static/media/HelveticaNeueLTStd-BlkEx.74fc46a4.otf";